import React, { FunctionComponent } from 'react';
import { Navigate } from 'react-router-dom';
import { Loader } from 'rs-emd-ui-atoms';
import { useQuoteConfirmationPageQuery } from '../../generated/graphql';
import { QuoteConfirmation } from '../../rs-emd-ui-modules/src/components/basket-purchase/quote-confirmation';
import { RedirectWithStatus } from '../../rs-emd-ui-modules/src/helpers/redirect-with-status.component';
import { IContextInfo } from '../../rs-emd-ui-modules/src/models/master/context-info.model';

type QuoteConfirmationPageWrapperProps = {
  contextInfo: IContextInfo;
};

export const QuoteConfirmationPageWrapper: FunctionComponent<QuoteConfirmationPageWrapperProps> = (
  props: QuoteConfirmationPageWrapperProps
) => {
  const { loading, error, data } = useQuoteConfirmationPageQuery({
    ssr: true,
    fetchPolicy: 'no-cache',
  });

  if (loading) {
    return <Loader />;
  } else if (error || !data) {
    return <RedirectWithStatus to={process.env.REACT_APP_ERROR_ENDPOINT} statusCode={500} />;
  } else if (!data.quoteConfirmationPage.isSuccess || !data.quoteConfirmationPage.quote) {
    return <Navigate to='/cart' />;
  }

  return <QuoteConfirmation data={data.quoteConfirmationPage} locale={props.contextInfo.locale} />;
};

export default QuoteConfirmationPageWrapper;
